/* eslint-disable no-throw-literal */
import ApiService from 'app/services/ApiService';


export const FETCH_DISCLAIMER_ACTIVE_BEGIN = 'FETCH_DISCLAIMER_ACTIVE_BEGIN';
export const FETCH_DISCLAIMER_ACTIVE_SUCCESS = 'FETCH_DISCLAIMER_ACTIVE_SUCCESS';
export const FETCH_DISCLAIMER_ACTIVE_FAILURE = 'FETCH_DISCLAIMER_ACTIVE_FAILURE';



export function fetchDisclaimerActive() {
    return async dispatch => {
        dispatch(fetchDisclaimerActiveBegin())
        await ApiService.getDisclaimerActive()
            .then(
                result => {
                    dispatch(fetchDisclaimerActiveSuccess(result));

                },
                error => {
                    dispatch(fetchDisclaimerActiveFailure());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }
}


export const fetchDisclaimerActiveBegin = () => ({
    type: FETCH_DISCLAIMER_ACTIVE_BEGIN,
});
export const fetchDisclaimerActiveSuccess = data => ({
    type: FETCH_DISCLAIMER_ACTIVE_SUCCESS,
    payload: data
});
export const fetchDisclaimerActiveFailure = () => ({
    type: FETCH_DISCLAIMER_ACTIVE_FAILURE,
});


